import {
    ListItemIcon,
    ListItemText,
    MenuItem,
    Typography
} from '@mui/material';
import PeopleIcon from '@mui/icons-material/People';
import React from 'react';
import { useTheme } from '@mui/material/styles';

/**
 * Renders a menu item for the 'Vs Peer Group' portfolio option, including styled text and icon
 * @component
 * @param {Object} props - Any additional props to apply to MenuItem
 * @returns {React.ReactElement}
 */
export const VsPeerGroupsMenuItem = ({ ...props }) => {
    const theme = useTheme();

    return (
        <MenuItem dense {...props} data-analyticsid='vs-peer-group'>
            <ListItemIcon>
                <PeopleIcon
                    sx={{
                        color: theme.palette.kimberley.darkest,
                        transform: 'scale(1.1)'
                    }}
                />
            </ListItemIcon>
            <ListItemText>
                <Typography
                    variant='body2'
                    sx={{ color: theme.palette.kimberley.darkest }}
                >
                    Vs. Peer Group
                </Typography>
            </ListItemText>
        </MenuItem>
    );
};
